import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IOnChangesObject, IScope} from "angular";
import {Språk} from "felles/tjenester/i18n/Spraak";
import {Språkvalg} from "felles/tjenester/i18n/Spraakvalg";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {dersomChangesInneholder} from "../../felles/stoettefunk/angularHjelpemetoder";
import {BoolskStreng} from "../../types/delteTyper";

const css = require('./spraakvelger.scss');

export class SpråkvelgerKontroller implements IController {
    static språkValgtEvent = "språkvalgtEvent";

    static registrerKomponent(angular: IModule) {
        angular.component('spraakvelger', {
            bindings: {spraakKode: '=?', kunVisning: '@?'},
            controller: SpråkvelgerKontroller.forInjisering(),
            template: require('./spraakvelger.html')
        });
    }

    static forInjisering() {
        return [regNavn.ng.$scope, regNavn.gettext.gettextCatalog, Språkvalg.regNavn, SpråkvelgerKontroller]
    }

    constructor(private $scope: IScope, private gettextCatalog: gettextCatalog, private språkvalg: Språkvalg) {
    }

    spraakKode: string; //settes via bindings/$onChanges
    kunVisning: BoolskStreng; //settes via bindings/$onChanges

    erKunVisning = false;
    valgtSpraak: Språk;
    spraak: Språk[];

    spraakSelect:string

    onchanageSpraak(){
        this.spraakValgt(this.spraakSelect)
    }

    spraakValgt(servertag) {
        if (this.erKunVisning) return;

        this.valgtSpraak = Språk.finnSpråkFraTag(servertag);
        if (_.isNil(this.valgtSpraak)) return;

        this.spraakKode = this.valgtSpraak.servertag;
        // endrer ikke eksisterende instanser på siden. F.eks. er moment avhengig av at event fyres i språkvalg for å få lastet horisontal møtenavigasjon på nytt.
        this.språkvalg.angiSpråkOgPersister(this.valgtSpraak);
        this.$scope.$root.$emit(SpråkvelgerKontroller.språkValgtEvent, this.valgtSpraak);
    }

    $onInit(): void {
        if (this.kunVisning == 'true'){
            this.erKunVisning = true;
            this.valgtSpraak = Språk.finnSpråkFraTag(this.spraakKode);
            return;
        }
        //@todo lytt til språk-endret event og oppdatere valgtSpraak?
        this.valgtSpraak = this.språkvalg.aktivtSpråk()
        this.spraak = this.språkvalg.tilgjengeligSpråk();
        this.spraakSelect = this.valgtSpraak.servertag
    }

    $onChanges(endringer: IOnChangesObject): void {
        dersomChangesInneholder(endringer, 'spraakKode', () => {
            if (this.erKunVisning) this.valgtSpraak = Språk.finnSpråkFraTag(this.spraakKode);
        });
    }


    hentValgtSpaakOversatt():string{
        if (this.valgtSpraak.servertag == 'nb') return this.gettextCatalog.getString('Bokmål');
        if (this.valgtSpraak.servertag == 'nn') return this.gettextCatalog.getString('Nynorsk');
        if (this.valgtSpraak.servertag == 'en') return this.gettextCatalog.getString('Engelsk');
        return "Norsk" // bør aldri skje
    }

}
